import React from 'react';

export default () => (
	<footer className='footer'>
		<div className='footer-content'>
		©2024 Affordable Foundation Repair
		</div>
	</footer>
);
